import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import * as ComponentTable from './Components';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { Objeto } from '../../Services/Models';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { Button, FormGroup, Icon, MenuItem, Checkbox, Collapse, Divider } from '@blueprintjs/core';
import { IconeHome } from '../../Assets';
import moment from 'moment';
import { DateInput } from "@blueprintjs/datetime";
import { Select, MultiSelect } from "@blueprintjs/select";
import { CentroDeCusto, Identificador } from '../../Services/Controllers';
import { SignIn as ContextSignIn } from '../../Context';
import './style.css';
import { api, pythonApi } from './Services/api';
import apiAdonis from '../../Services/adonis';
import * as LottieFiles from '../../Data/Lottie/index'
import Lottie from 'react-lottie';
import { Visualizacao } from '../Mapas/map_components';
import Carteira from '../Analytics/Components/Carteira';

const View: React.FC = (viewModel) => {
  const History = useHistory();

  const PropriedadesDeCalendario = {
    months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    weekdaysShort: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']
  };
  //Controles
  const [getCollapse, setCollapse] = useState(false)
  const [getFilterClicked, setFilterClicked] = useState(false)
  //Fluxo
  const [visualizacao, setVisualizacao] = useState<any>("fluxo de caixa");
  const [getFormularioDataDeInicio, setFormularioDataDeInicio] = useState<any>();
  const [getFormularioDataDeTermino, setFormularioDataDeTermino] = useState<any>();
  const [getSearch, setSearch] = useState<boolean>(false);

  const [getEmp, setEmp] = useState<string>();
  const [getCodEmp, setCodEmp] = useState<string>();
  const [getCodEmpObra, setCodEmpObra] = useState<string>();
  const [getProduto, setProduto] = useState<string>();
  const [getStatus, setStatus] = useState<string>();
  const [getFiltro, setFiltro] = useState<string>();
  const [getQuerysTime, setQuerysTime] = useState<Array<string>>([]);
  const [getQuerysLoading, setQuerysLoading] = useState<boolean>(false);

  const [getDivisao, setDivisao] = useStateWithCallbackLazy<string>('');
  const [getCheckEmpresa, setCheckEmpresa] = useState<boolean>(false);
  const [getCheckPessoais, setCheckPessoais] = useState<boolean>(false);
  const [getCheckEmpreendimentos, setCheckEmpreendimentos] = useState<boolean>(false);

  const [getFluxoData, setFluxoData] = useState<Objeto.FluxoData>();
  const [getPlanejamentoData, setPlanejamentoData] = useState<Objeto.Planejamento>();
  const [getVendasSemCessaoData, setVendasSemCessaoData] = useState<any>();
  const [getVendasDeCessaoData, setVendasDeCessaoData] = useState<any>();
  const [getVendasDistratadasData, setVendasDistratadasData] = useState<any>();
  const [getDepositosData, setDepositosData] = useState<any>();
  const [getVendasNoTempoData, setVendasNoTempoData] = useState<any>();
  const [getAPagarData, setAPagarData] = useState<any>();
  const [getProvisaoDeDistratoData, setProvisaoDeDistratoData] = useState<any>();
  const [getDisponibilidadeData, setDisponibilidadeData] = useState<any>();
  const [getSaldoInicial, setSaldoInicial] = useState<any>();
  const [getDesembolsoData, setDesembolsoData] = useState<any>();

  //Tables
  const [getTableSelected, setTableSelected] = useState<number>(0);
  const [getOpacity, setOpacity] = useState<boolean>(false);
  const [getVisaoTempo, setVisaoTempo] = useState<string | undefined>(undefined);

  /*CasaEterra*/
  const [getItemPickerVisao, setItemPickerVisao] = useState<{ mesAno: string, sigla: string }>();
  const [getListaPickerVisao, setListaPickerVisao] = useState<Array<{ mesAno: string, sigla: string }>>([]);
  const PickerVisao = Select.ofType<{ mesAno: string, sigla: string }>();

  const [getItemPickerEmpresas, setItemPickerEmpresas] = useState<Objeto.EmpresasModel>();
  const [getListaPickerEmpresas, setListaPickerEmpresas] = useState<Array<Objeto.EmpresasModel>>([]);
  const PickerEmpresas = Select.ofType<Objeto.EmpresasModel>();
  const [getEmpresa, setEmpresa] = useState<string>();

  const [getItemPickerObras, setItemPickerObras] = useState<Objeto.ObrasModel>();
  const [getListaPickerObras, setListaPickerObras] = useState<Array<Objeto.ObrasModel>>([]);
  const PickerObras = Select.ofType<Objeto.ObrasModel>();
  const [getObra, setObra] = useState<string>();
  /* # */
  const [getItemPickerCentroDeCusto, setItemPickerCentroDeCusto] = useState<Objeto.CentroDeCusto>();
  const [getListaPickerCentroDeCusto, setListaPickerCentroDeCusto] = useState<Array<Objeto.CentroDeCusto>>([]);
  const PickerCentroDeCusto = Select.ofType<Objeto.CentroDeCusto>();

  const [getItemPickerProduto, setItemPickerProduto] = useState<Objeto.ProdutoModel>();
  const [getListaPickerProduto, setListaPickerProduto] = useState<Array<Objeto.ProdutoModel>>([]);
  const PickerProduto = Select.ofType<Objeto.ProdutoModel>();

  const [getItemPickerEmpreendimento, setItemPickerEmpreendimento] = useState<Objeto.EmpreendimentoPicker>();
  const [getListaPickerEmpreendimento, setListaPickerEmpreendimento] = useState<Array<Objeto.EmpreendimentoPicker>>([]);
  const PickerEmpreendimento = Select.ofType<Objeto.EmpreendimentoPicker>();

  const [getItemPickerStatus, setItemPickerStatus] = useState<Objeto.StatusPicker>();
  const [getListaPickerStatus, setListaPickerStatus] = useState<Array<Objeto.StatusPicker>>([]);
  const PickerStatus = Select.ofType<Objeto.StatusPicker>();

  const [getItemPickerGrupo, setItemPickerGrupo] = useState<Objeto.GrupoModel>();
  const [getListaPickerGrupo, setListaPickerGrupo] = useState<Array<Objeto.GrupoModel>>([]);
  const PickerGrupo = Select.ofType<Objeto.GrupoModel>();

  const [cd_emp, setCdEmp] = useState<number>();
  const [tabelaEmp, setTabelaEmp] = useState<string>();
  const [fluxoTipo, setFluxoTipo] = useState<string>();

  async function getEmpTipo() {
    await apiAdonis.get("/empPerms", {
      params: { userId: JSON.parse(localStorage.getItem("user") ?? "{}").id }
    }).then(res => {
      const emp_permissions: { cd_emp: number }[] | [] = res.data;
      if (emp_permissions.length > 1) {
        const options: any = [];
        let prompt_text;

        let i = ""
        emp_permissions.forEach(emp => {
          const emp_name = emp.cd_emp === 1 ? "Rio" :
            emp.cd_emp === 2 ? "Gav" :
              emp.cd_emp === 3 ? "Omie" :
                emp.cd_emp === 4 ? "BP8" :
                  emp.cd_emp === 20 ? "Espaco" :
                    emp.cd_emp === 25 ? "CasaETerra" : null;
          i += `${emp.cd_emp} - ${emp_name}\n`
          options.push({ cd_emp: emp.cd_emp, emp_name: emp_name })
        })
        prompt_text = i;

        let choose = prompt(prompt_text);
        while (!options.find((option: any) => option.cd_emp === Number(choose))) {
          choose = prompt(prompt_text);
        }
        setCdEmp(options.find((option: any) => option.cd_emp === Number(choose)).cd_emp);
      }
      else {
        setCdEmp(emp_permissions[0].cd_emp)
      }
    })

    return
  }
  async function VerifyToken() {

    await apiAdonis.post('/verify', {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(async result => {
      if (result.data.check) {
        return null
      }
      else {
        History.replace("/");
        window.location.reload();
      }
    });
  }

  useEffect(() => {
    async function componentDidMount() {
      await VerifyToken();
      await getEmpTipo();
    }
    componentDidMount();
  }, [])

  useEffect(() => {
    if (cd_emp) {
      switch (cd_emp) {
        case 1:
          setFluxoTipo("Fluxo");
          setTabelaEmp("Rio")
          break
        case 4:
          setTabelaEmp("BP8")
          break
        case 20:
          setFluxoTipo("Fluxo");
          setTabelaEmp("Espaco")
          break
        case 25:
          setTabelaEmp("CasaeTerra")
          break
      }
    }
  }, [cd_emp])

  useEffect(() => {
    async function componentDidMount() {
      switch (window.location.pathname) {
        case "/Menu/Analytics/Resumo":
          await setTableSelected(0);
          break;
        case "/Menu/Analytics/Vendas":
          await setTableSelected(1);
          await api.get('/getFiltroVendas?empresa=undefined&obra=undefined').then(async res => {
            await setListaPickerEmpresas(res.data.filtroEmpresas);
            await setListaPickerObras(res.data.filtroObras);
          })
          await api.get('/VendasSemCessao?empresa=undefined&obra=undefined&dataInicial=undefined&dataFinal=undefined').then(async res => {
            await setVendasSemCessaoData(res.data)
            console.log(res.data)
          })
          break;
        case "/Menu/Analytics/Cessao":
          await setTableSelected(2);
          await api.get('/getFiltroVendas?empresa=undefined&obra=undefined').then(async res => {
            await setListaPickerEmpresas(res.data.filtroEmpresas);
            await setListaPickerObras(res.data.filtroObras);
          })
          await api.get('/VendasDeCessao?empresa=undefined&obra=undefined&dataInicial=undefined&dataFinal=undefined').then(async res => {
            await setVendasDeCessaoData(res.data)
            console.log(res.data)
          })
          break;
        case "/Menu/Analytics/Distratos":
          await setTableSelected(3);
          await api.get(`/getFiltroVendas?empresa=undefined&obra=undefined&tabelaEmp=${tabelaEmp}`).then(async res => {
            await setListaPickerEmpresas(res.data.filtroEmpresas);
            await setListaPickerObras(res.data.filtroObras);
          })
          await api.get(`/distratos?codEmp=undefined&codEmpObra=undefined&dataInicial=undefined&dataFinal=undefined&tabelaEmp=${tabelaEmp}`).then(async res => {
            await setVendasDistratadasData(res.data)
            console.log(res.data)
          })
          break;
        case "/Menu/Analytics/Depositos":
          await setTableSelected(4);
          await api.get('/getFiltroVendas?empresa=undefined&obra=undefined').then(async res => {
            await setListaPickerEmpresas(res.data.filtroEmpresas);
            await setListaPickerObras(res.data.filtroObras);
          })
          // api.get('/Depositos?empresa=undefined&obra=undefined&dataInicial=undefined&dataFinal=undefined').then(async res => {
          //   await setDepositosData(res.data)
          //   console.log(res.data)
          // })
          break;
        case "/Menu/Analytics/Provisao":
          await setTableSelected(5);
          break;
        case "/Menu/Analytics/VendaNoTempo":
          await setTableSelected(6);
          await api.get(`/getFiltroMesAnos?tabelaEmp=${tabelaEmp}`).then(async res => {
            await setListaPickerVisao(res.data.mesAnos);
          })
          await api.get(`/getFiltroVendas?empresa=undefined&obra=undefined&tabelaEmp=${tabelaEmp}`).then(async res => {
            await setListaPickerEmpresas(res.data.filtroEmpresas);
            await setListaPickerObras(res.data.filtroObras);
          })
          break;
        case "/Menu/Analytics/Fluxo":
          await setFilterClicked(false);
          await setTableSelected(7);
          await pythonApi.get(`getTime/${tabelaEmp}`).then(async response => {
            await setQuerysTime([response.data.started, response.data.finished]);
          })
          api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`).then(res => setListaPickerGrupo(res.data.filtroEmpresas));
          await setListaPickerEmpreendimento(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroObras);
          break;
          case "/Menu/Analytics/Carteira":
          await setFilterClicked(false);
          await setTableSelected(11);
          await pythonApi.get(`getTime/${tabelaEmp}`).then(async response => {
            await setQuerysTime([response.data.started, response.data.finished]);
          })
          api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`).then(res => setListaPickerGrupo(res.data.filtroEmpresas));
          await setListaPickerEmpreendimento(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroObras);
          break;
        case "/Menu/Analytics/Desembolso":
          await setFilterClicked(false);
          await setTableSelected(12);
          await pythonApi.get(`getTime/${tabelaEmp}`).then(async response => {
            await setQuerysTime([response.data.started, response.data.finished]);
          })
          api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`).then(res => setListaPickerGrupo(res.data.filtroEmpresas));
          await setListaPickerEmpreendimento(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroObras);
          await setListaPickerProduto(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroProdutos);
          break;
        case "/Menu/Analytics/Planejamento":
          await setFilterClicked(false);
          await setTableSelected(8);
          await pythonApi.get(`getTime/${tabelaEmp}`).then(async response => {
            await setQuerysTime([response.data.started, response.data.finished]);
          })
          api.get(`/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&tabelaEmp=${tabelaEmp}`).then(res => setListaPickerGrupo(res.data.filtroEmpresas))
          await setListaPickerEmpreendimento(await (await (api.get(`/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&tabelaEmp=${tabelaEmp}&divisao=undefined`))).data.filtroObras);
          await setListaPickerProduto(await (await (api.get(`/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&tabelaEmp=${tabelaEmp}&divisao=undefined`))).data.filtroProdutos);
          await setListaPickerStatus(await (await (api.get(`/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&tabelaEmp=${tabelaEmp}&status=undefined`))).data.filtroStatus);
          break;
        case "/Menu/Analytics/Realizar":
          await setFilterClicked(false);
          await setTableSelected(9);
          await pythonApi.get(`getTime/${tabelaEmp}`).then(async response => {
            await setQuerysTime([response.data.started, response.data.finished]);
          })

          await api.get(`getFiltroPlan?codEmp=undefined&codEmpObra=undefined&tabelaEmp=${tabelaEmp}`).then(res => setListaPickerGrupo(res.data.filtroEmpresas))
          await setListaPickerEmpreendimento(await (await (api.get(`/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&tabelaEmp=${tabelaEmp}&divisao=undefined`))).data.filtroObras);
          await setListaPickerProduto(await (await (api.get(`/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&tabelaEmp=${tabelaEmp}&divisao=undefined`))).data.filtroProdutos);
          await setListaPickerStatus(await (await (api.get(`/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&tabelaEmp=${tabelaEmp}&status=undefined`))).data.filtroStatus);
          break;
        case "/Menu/Analytics/Financeiro":
          await setFilterClicked(false);
          await setTableSelected(9);
          await pythonApi.get('getTime').then(async response => {
            await setQuerysTime([response.data.started, response.data.finished]);
          })

          await api.get('/getFiltroPlan?codEmp=undefined&codEmpObra=undefined').then(res => setListaPickerGrupo(res.data.filtroEmpresas))
          await setListaPickerEmpreendimento(await (await (api.get('/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&divisao=undefined'))).data.filtroObras);
          await setListaPickerProduto(await (await (api.get('/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&divisao=undefined'))).data.filtroProdutos);
          await setListaPickerStatus(await (await (api.get('/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&status=undefined'))).data.filtroStatus);
          break;
          await setTableSelected(5);
          break;
        case "/Menu/Analytics/ProvisaoDeDistrato":
          await setTableSelected(10);
          break;
        case "/Menu/Analytics/Carteira":
          await setTableSelected(11);
          break;
      }
    }

    tabelaEmp && componentDidMount();
  }, [tabelaEmp])
  return (
    <div style={{ backgroundColor: "#EDEFF5", width: "100%", height: "100vh", overflow: "auto" }}>
      {/* Collapse => Endereco + Filtros */}
      <Collapse isOpen={getCollapse}>
        <div style={{ backgroundColor: "#f0f0ff", width: "100%", height: "95px", display: "flex", alignItems: "center", paddingLeft: "2%" }}>
          <img style={{ width: "20px", height: "20px" }} src={IconeHome} alt="" />
          <div className="bar">/</div>
          <div className="place">Analytics</div>
          <div className="bar">/</div>
          <div className="place">
            {
              getTableSelected == -1 ? "" :
                getTableSelected == 0 ? "Resumo" :
                  getTableSelected == 1 ? "Vendas" :
                    getTableSelected == 2 ? "Cessão" :
                      getTableSelected == 3 ? "Distratos" :
                        getTableSelected == 4 ? "Depósitos" :
                          getTableSelected == 5 ? "Provisão" :
                            getTableSelected == 6 ? "Gestão Receita" :
                              getTableSelected == 7 ? "Fluxo" :
                                getTableSelected == 8 ? "Planejamento" :
                                  getTableSelected == 9 ? "Realizar" :
                                    getTableSelected == 10 ? "Tesouraria" :
                                      getTableSelected == 11 ? "Carteira" : "260"
            }
          </div>
          {(getTableSelected === 6) &&
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "0", width: "100%" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "0", width: "45%", marginLeft: "2%" }}>
                <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />

                <PickerEmpresas popoverProps={{ popoverClassName: "bp3-multi-select-popover" }} items={getListaPickerEmpresas} onItemSelect={() => { }} noResults={<MenuItem disabled={true} text="Sem resultados disponíveis" />}
                  itemRenderer={(Item: Objeto.EmpresasModel) => <MenuItem onClick={async () => {
                    await setItemPickerEmpresas(Item);
                    await setEmpresa(Item.KEY_CDEMP_BD);
                    await setEmp(Item.CDEMP);

                    await api.get(`/getFiltroVendas?empresa=${Item.KEY_CDEMP_BD}&obra=undefined&tabelaEmp=${tabelaEmp}`).then(async res => {
                      await setListaPickerObras(res.data.filtroObras)
                    })
                  }} text={`${Item.CDEMP} - ${Item.NM_Empresa}`} />} itemPredicate={(Texto: string, Item: Objeto.EmpresasModel) => { return (Item.NM_Empresa ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                  <Button className="selector" style={{ background: "#ffffff", color: "#13455e", border: "none", boxShadow: "none", borderRadius: "5px", outline: "none", width: "150px", display: "flex", alignItems: "center", justifyContent: "space-between" }} text={(getItemPickerEmpresas ? `${getItemPickerEmpresas?.CDEMP}-${getItemPickerEmpresas?.NM_Empresa}` : "Empresa").substring(0, 10).concat("...") ?? "Empresa"} rightIcon="double-caret-vertical" />
                </PickerEmpresas>
                {getItemPickerEmpresas && <Icon icon="filter-remove" style={{ marginLeft: "5px", cursor: "pointer" }} iconSize={15} onClick={async () => {
                  await setItemPickerEmpresas(undefined);
                  await setItemPickerObras(undefined);
                  await setEmpresa(undefined);
                  await setObra(undefined);
                  await setEmp(undefined);

                  await api.get(`/getFiltroVendas?empresa=undefined&obra=undefined&tabelaEmp=${tabelaEmp}`).then(async res => {
                    await setListaPickerEmpresas(res.data.filtroEmpresas);
                    await setListaPickerObras(res.data.filtroObras);
                  })
                }} />}

                <PickerObras popoverProps={{ popoverClassName: "bp3-multi-select-popover" }} items={getListaPickerObras} onItemSelect={() => { }} noResults={<MenuItem disabled={true} text="Sem resultados disponíveis" />}
                  itemRenderer={(Item: Objeto.ObrasModel) => <MenuItem onClick={async () => {
                    await setItemPickerObras(Item);
                    await setObra(Item.KEY_CDEMP_CDOBR_BD)

                    await api.get(`/getFiltroVendas?empresa=undefined&obra=${Item.KEY_CDEMP_BD}&tabelaEmp=${tabelaEmp}`).then(async res => {
                      await setListaPickerEmpresas(res.data.filtroEmpresas)
                    })
                  }} text={`${Item.CodObra} - ${Item.NM_Obra}`} />} itemPredicate={(Texto: string, Item: Objeto.ObrasModel) => { return (Item.NM_Obra ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                  <Button className="selector" style={{ background: "#ffffff", color: "#13455e", border: "none", boxShadow: "none", borderRadius: "5px", outline: "none", width: "150px", display: "flex", alignItems: "center", justifyContent: "space-between" }} text={(getItemPickerObras ? `${getItemPickerObras?.CodObra}-${getItemPickerObras?.NM_Obra}` : "Obra").substring(0, 10).concat("...") ?? "Obra"} rightIcon="double-caret-vertical" />
                </PickerObras>
                {getItemPickerObras && <Icon icon="filter-remove" style={{ marginLeft: "5px", cursor: "pointer" }} iconSize={15} onClick={async () => {
                  await setItemPickerEmpresas(undefined);
                  await setItemPickerObras(undefined);
                  await setEmpresa(undefined);
                  await setObra(undefined);
                  await setEmp(undefined);

                  await api.get(`/getFiltroVendas?empresa=undefined&obra=undefined&tabelaEmp=${tabelaEmp}`).then(async res => {
                    await setListaPickerEmpresas(res.data.filtroEmpresas);
                    await setListaPickerObras(res.data.filtroObras);
                  })
                }} />}

                <PickerVisao popoverProps={{ popoverClassName: "bp3-multi-select-popover" }} items={getListaPickerVisao} onItemSelect={() => { }} noResults={<MenuItem disabled={true} text="Sem resultados disponíveis" />}
                  itemRenderer={(Item: { mesAno: string, sigla: string }) => <MenuItem onClick={async () => {
                    await setItemPickerVisao(Item);
                    await setVisaoTempo(Item.sigla);
                  }} text={Item.mesAno} />} itemPredicate={(Texto: string, Item: { mesAno: string, sigla: string }) => { return (Item.mesAno ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                  <Button className="selector" style={{ background: "#ffffff", color: "#13455e", border: "none", boxShadow: "none", borderRadius: "5px", outline: "none", width: "150px", display: "flex", alignItems: "center", justifyContent: "space-between" }} text={getItemPickerVisao?.mesAno ?? "Data da Visão"} rightIcon="double-caret-vertical" />
                </PickerVisao>
                {getItemPickerObras && <Icon icon="filter-remove" style={{ marginLeft: "5px", cursor: "pointer" }} iconSize={15} onClick={async () => {
                  await setItemPickerEmpresas(undefined);
                  await setItemPickerObras(undefined);
                  await setEmpresa(undefined);
                  await setObra(undefined);
                  await setItemPickerVisao(undefined);

                  await api.get(`/getFiltroVendas?empresa=undefined&obra=undefined&tabelaEmp=${tabelaEmp}`).then(async res => {
                    await setListaPickerEmpresas(res.data.filtroEmpresas);
                    await setListaPickerObras(res.data.filtroObras);
                  })
                }} />}

              </div>
              
              <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "0", width: "45%", marginLeft: "2%" }}>
              <div 
                    style={{ 
                      width: "110px", 
                      background: "#ffffff", 
                      marginBottom: "50px",
                      height: "30px", 
                      color: "#175372", 
                      boxShadow: "0px 0px 0px 1px #d8d8d8", 
                      fontSize:"13px",
                      borderRadius: "5px", 
                  cursor: "pointer" }}

                onClick={async () => {
                  if (getEmp !== undefined && getVisaoTempo !== undefined) {
                    await setCollapse(false);
                    await setTableSelected(-1);
                    await api.get(`/VendasNoTempo/${window.location.pathname === '/Menu/Analytics/VendaNoTempo' ? "VendaNoTempo" : "ProvisaoDeDistrato"}?empresa=${getEmpresa}&obra=${getObra}&emp=${getEmp}&MesAno=${getVisaoTempo}&tabelaEmp=${tabelaEmp}`).then(async res => {
                      window.location.pathname === '/Menu/Analytics/VendaNoTempo' ? await setTableSelected(6) : setTableSelected(10);
                      window.location.pathname === '/Menu/Analytics/VendaNoTempo' ? setVendasNoTempoData(res.data) : setProvisaoDeDistratoData(res.data);
                    })
                  }
                  else {
                    alert('Selecione uma empresa e uma data')
                  }
                }}>
                <Icon color="#175372" style={{ marginLeft:"10px", marginTop:"5px",transform: getFilterClicked ? "rotate(0deg)" : "rotate(-360deg)", transition: getFilterClicked ? "transform 2s" : "" }} icon="search" />
                <span style={{marginLeft:"10px"}}>Pesquisar</span>
                {/* Insercao do botao atualizar 25-08 */}
                <div>
                <div className="#hoverize" 
                style={{ 
                  marginTop: "20px",
                  width: "110px", 
                  height: "30px", 
                  background: "#175372", 
                  fontSize: "13px", 
                  color: "#ffffff", 
                  boxShadow: "0px 0px 0px 1px #d8d8d8", 
                  padding: "0 5px", 
                  borderRadius: "5px", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "space-around", 
                  cursor: "pointer", 
                  pointerEvents: getQuerysLoading ? "none" : "initial" }}
                  
                    onClick={async () => {
                      alert(JSON.stringify({
                        nm_emp: getItemPickerEmpresas?.NM_Empresa,
                        mesAnos: getItemPickerVisao?.mesAno
                      }))
                      if (!getQuerysLoading) {
                        await setQuerysLoading(true);
                        await api.post(`/csv`, {
                          nm_emp: getItemPickerEmpresas?.NM_Empresa,
                          mesAnos: getItemPickerVisao?.mesAno
                        }).then(async response => {
                          await setQuerysTime([response.data.started, response.data.finished])
                          await setQuerysLoading(false)
                        })
                      }
                    }}>
                    {!getQuerysLoading && <Icon iconSize={10} color="#ffffff" style={{ transform: getFilterClicked ? "rotate(0deg)" : "rotate(-360deg)", transition: getFilterClicked ? "transform 2s" : "" }} icon="repeat" />}
                    {getQuerysLoading &&
                      <Lottie
                        options={{
                          loop: true,
                          autoplay: true,
                          animationData: LottieFiles.LoadingQuerys,
                          rendererSettings: {
                            preserveAspectRatio: "xMidYMid slice"
                          }
                        }}
                        height={17}
                        width={17}
                      />}
                    {!getQuerysLoading && <span>Atualizar</span>}
                  </div>
                  <span style={{ fontSize: "9px", color: "#ff6961" }}>Atualizado às {getQuerysTime[1]}</span>
                </div>
              </div>
              </div>
            </div>}
          {(getTableSelected !== 7 && getTableSelected !== 8 && getTableSelected !== 6 && getTableSelected !== 9 && getTableSelected !== 10 && getTableSelected !== 12) &&
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "0", width: "100%" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "0", width: "75%", marginLeft: "2%" }}>
                <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />
                <PickerEmpresas popoverProps={{ popoverClassName: "bp3-multi-select-popover" }} items={getListaPickerEmpresas} onItemSelect={() => { }} noResults={<MenuItem disabled={true} text="Sem resultados disponíveis" />}
                  itemRenderer={(Item: Objeto.EmpresasModel) => <MenuItem onClick={async () => {
                    await setItemPickerEmpresas(Item);
                    await setEmpresa(Item.KEY_CDEMP_BD);
                    await setEmp(Item.CDEMP)

                    await api.get(`/getFiltroVendas?empresa=${Item.KEY_CDEMP_BD}&obra=undefined&tabelaEmp=${tabelaEmp}`).then(async res => {
                      await setListaPickerObras(res.data.filtroObras)
                    })
                  }} text={`${Item.CDEMP}-${Item.NM_Empresa}`} />} itemPredicate={(Texto: string, Item: Objeto.EmpresasModel) => { return (`${Item.CDEMP}-${Item.NM_Empresa}` ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                  <Button className="selector" style={{ background: "#ffffff", color: "#13455e", border: "none", boxShadow: "none", borderRadius: "5px", outline: "none", width: "150px", display: "flex", alignItems: "center", justifyContent: "space-between" }} text={(getItemPickerEmpresas ? `${getItemPickerEmpresas?.CDEMP}-${getItemPickerEmpresas?.NM_Empresa}` : "Empresa").substring(0, 10).concat("...") ?? "Empresa"} rightIcon="double-caret-vertical" />
                </PickerEmpresas>
                {getItemPickerEmpresas && <Icon icon="filter-remove" style={{ marginLeft: "5px", cursor: "pointer" }} iconSize={15} onClick={async () => {
                  await setItemPickerEmpresas(undefined);
                  await setItemPickerObras(undefined);
                  await setEmpresa(undefined);
                  await setObra(undefined);
                  await setEmp(undefined)

                  await api.get(`/getFiltroVendas?empresa=undefined&obra=undefined&tabelaEmp=${tabelaEmp}`).then(async res => {
                    await setListaPickerEmpresas(res.data.filtroEmpresas);
                    await setListaPickerObras(res.data.filtroObras);
                  })
                }} />}

                <PickerObras popoverProps={{ popoverClassName: "bp3-multi-select-popover" }} items={getListaPickerObras} onItemSelect={() => { }} noResults={<MenuItem disabled={true} text="Sem resultados disponíveis" />}
                  itemRenderer={(Item: Objeto.ObrasModel) => <MenuItem onClick={async () => {
                    await setItemPickerObras(Item);
                    getTableSelected === 4 ? await setObra(Item.Desc_Obra) : await setObra(Item.KEY_CDEMP_CDOBR_BD)
                    await api.get(`/getFiltroVendas?empresa=undefined&obra=${Item.KEY_CDEMP_BD}&tabelaEmp=${tabelaEmp}`).then(async res => {
                      await setListaPickerEmpresas(res.data.filtroEmpresas)
                    })
                  }} text={`${Item.CodObra}-${Item.NM_Obra}`} />} itemPredicate={(Texto: string, Item: Objeto.ObrasModel) => { return (`${Item.CodObra}-${Item.NM_Obra}` ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                  <Button className="selector" style={{ background: "#ffffff", color: "#13455e", border: "none", boxShadow: "none", borderRadius: "5px", outline: "none", width: "150px", display: "flex", alignItems: "center", justifyContent: "space-between" }} text={(getItemPickerObras ? `${getItemPickerObras?.CodObra}-${getItemPickerObras?.NM_Obra}` : "Obra").substring(0, 10).concat("...") ?? "Obra"} rightIcon="double-caret-vertical" />
                </PickerObras>
                {getItemPickerObras && <Icon icon="filter-remove" style={{ marginLeft: "5px", cursor: "pointer" }} iconSize={15} onClick={async () => {
                  await setItemPickerEmpresas(undefined);
                  await setItemPickerObras(undefined);
                  await setEmpresa(undefined);
                  await setObra(undefined);
                  await setEmp(undefined);

                  await api.get(`/getFiltroVendas?empresa=undefined&obra=undefined&tabelaEmp=${tabelaEmp}`).then(async res => {
                    await setListaPickerEmpresas(res.data.filtroEmpresas);
                    await setListaPickerObras(res.data.filtroObras);
                  })
                }} />}

                <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />
                {/* Data Picker */}
                <FormGroup className="place" label="Período:" labelFor="DataDeInicio" inline={true} style={{ marginTop: "15px" }}>
                  <div style={{ width: "100px" }}>
                    <DateInput dayPickerProps={PropriedadesDeCalendario} formatDate={(date, locale) => moment(date).locale(moment.locale(locale)).format("DD/MM/YYYY")}
                      parseDate={(str, locale) => moment(str, "DD/MM/YYYY").locale(moment.locale(locale)).toDate()}
                      placeholder={"Data Início"} value={getFormularioDataDeInicio} maxDate={getFormularioDataDeTermino}
                      onChange={async (DataSelecionada: Date) => {
                        //console.log(DataSelecionada)
                        if (DataSelecionada != null) {
                          await setFormularioDataDeInicio(DataSelecionada)
                        }
                        else {
                          await setFormularioDataDeInicio(getFormularioDataDeInicio)
                        }
                      }}>
                    </DateInput>
                  </div>
                </FormGroup>
                <span>à</span>
                <FormGroup className="place" label="" labelFor="DataDeTermino" inline={true} style={{ marginTop: "15px" }}>
                  <div style={{ width: "100px" }}>
                    <DateInput dayPickerProps={PropriedadesDeCalendario} formatDate={(date, locale) => moment(date).locale(moment.locale(locale)).format("DD/MM/YYYY")}
                      parseDate={(str, locale) => moment(str, "DD/MM/YYYY").locale(moment.locale(locale)).toDate()}
                      placeholder={"Data Final"} value={getFormularioDataDeTermino} minDate={getFormularioDataDeInicio} maxDate={new Date()}
                      onChange={async (DataSelecionada: Date) => {
                        //console.log(DataSelecionada)
                        if (DataSelecionada != null && DataSelecionada < getFormularioDataDeInicio) {
                          await setFormularioDataDeInicio(DataSelecionada)
                        }
                        if (DataSelecionada != null) {
                          await setFormularioDataDeTermino(DataSelecionada)
                        }
                        else if (DataSelecionada == null) {
                          await setFormularioDataDeTermino(getFormularioDataDeTermino)
                        }
                      }}>
                    </DateInput>
                  </div>
                </FormGroup>
              </div>
              <div className="hoverize" style={{ width: "110px", background: "#ffffff", marginRight: "110px", height: "40px", color: "#175372", boxShadow: "0px 0px 0px 1px #d8d8d8", padding: "0 5px", borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "space-around", cursor: "pointer" }}
                onClick={async () => {
                  switch (getTableSelected) {
                    case 0:
                      break
                    case 1:
                      setCollapse(false);
                      setTableSelected(-1);
                      api.get(`VendasSemCessao?empresa=${getEmpresa}&obra=${getObra}&dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}`).then(async res => {
                        console.log(`VendasSemCessao?empresa=${getEmpresa}&obra=${getObra}&dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}`)
                        console.log(res.data);
                        await setTableSelected(1);
                        setVendasSemCessaoData(res.data);
                      })
                      break
                    case 2:
                      setCollapse(false);
                      setTableSelected(-1);
                      await api.get(`VendasDeCessao?empresa=${getEmpresa}&obra=${getObra}&dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}`).then(async res => {
                        console.log(`VendasDeCessao?empresa=${getEmpresa}&obra=${getObra}&dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}`)
                        console.log(res.data);
                        await setTableSelected(2);
                        setVendasDeCessaoData(res.data)
                      })
                      break
                    case 3:
                      setCollapse(false);
                      setTableSelected(-1);
                      await api.get(`distratos?codEmp=${getEmpresa}&codEmpObra=${getObra}&dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&tabelaEmp=${tabelaEmp}`).then(async res => {
                        console.log(`distratos?empresa=${getEmpresa}&obra=${getObra}&dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&tabelaEmp=${tabelaEmp}`)
                        console.log(res.data)
                        await setTableSelected(3);
                        setVendasDistratadasData(res.data)
                      })
                      break
                    case 4:
                      if (getEmp !== undefined) {
                        setCollapse(false);
                        setTableSelected(-1);
                        await api.get(`Depositos?empresa=${getEmpresa}&Desc_Obra=${getObra}&dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&emp=${getEmp}`).then(async res => {
                          console.log(`Depositos?empresa=${getEmpresa}&Desc_Obra=${getObra}&dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&emp=${getEmp}`)
                          console.log(res.data);
                          await setTableSelected(4);
                          await setDepositosData(res.data);
                        })
                      }
                      else {
                        alert('Selecione uma empresa')
                      }
                      break
                    case 5:
                      break
                    case 6:
                      break
                  }
                }}>
                <Icon color="#175372" style={{ transform: getFilterClicked ? "rotate(0deg)" : "rotate(-360deg)", transition: getFilterClicked ? "transform 2s" : "" }} icon="search" />
                <span>Pesquisar</span>
              </div>
            </div>}
          {getTableSelected === 7 &&
            <div style={{ width: "100%", height: "100%", backgroundColor: "0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", width: "70%", minWidth: "1005px", background: "0", alignItems: "center", justifyContent: "space-between", paddingLeft: "2%" }}>
                <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />
                {/* Grupo Picker */}
                <PickerGrupo items={getListaPickerGrupo} onItemSelect={async () => { }} noResults={<MenuItem disabled={true} text="Sem resultados disponíveis" />}
                  itemRenderer={(Item: Objeto.GrupoModel) => <MenuItem onClick={async () => {
                    await setItemPickerGrupo(Item);
                    await setCodEmp(Item.KEY_CDEMP_BD);
                    console.log(`>>>>>>***** 1 - Empresa Selecionada => ${Item.NM_Empresa} *****<<<<<<<<`)
                    
                    api.get(`/getFiltro?codEmp=${Item.KEY_CDEMP_BD}&codEmpObra=${getCodEmpObra}&produto=${getProduto}&tabelaEmp=${tabelaEmp}`).then(async response => {
                      await setListaPickerEmpreendimento(response.data.filtroObras)
                      //await setListaPickerProduto(response.data.filtroProdutos)
                    })
                    //await setListaPickerProduto(await (await (api.get(`/getProduto?codEmpObra=${getCodEmpObra}&codEmp=${getCodEmp}`))).data);
                  }} text={Item.NM_Empresa} />} itemPredicate={(Texto: string, Item: Objeto.GrupoModel) => { return (Item.NM_Empresa ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                  <Button className="selector" style={{ background: "#ffffff", color: "#13455e", border: "none", boxShadow: "none", borderRadius: "5px", outline: "none", width: "150px", display: "flex", alignItems: "center", justifyContent: "space-between" }} text={getItemPickerGrupo?.NM_Empresa.substring(0, 10).concat("...") ?? "Empresa"} rightIcon="double-caret-vertical" />
                </PickerGrupo>
                {getItemPickerGrupo && <Icon icon="filter-remove" style={{ marginLeft: "5px", cursor: "pointer" }} iconSize={15} onClick={async () => {
                  await setItemPickerGrupo(undefined);
                  await setItemPickerEmpreendimento(undefined);
                  //await setItemPickerProduto(undefined);
                  await setCodEmp(undefined)
                  await setCodEmpObra(undefined)
                  // await setProduto(undefined)

                  await setListaPickerGrupo(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroEmpresas);
                  await setListaPickerEmpreendimento(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroObras);
                  // await setListaPickerProduto(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroProdutos);
                }} />}
                {/* Empreendimento Picker */}
                <PickerEmpreendimento popoverProps={{ popoverClassName: "bp3-multi-select-popover" }} items={getListaPickerEmpreendimento} onItemSelect={async () => { }} noResults={<MenuItem disabled={true} text="Sem resultados disponíveis" />}
                  itemRenderer={(Item: Objeto.EmpreendimentoPicker) => <MenuItem onClick={async () => {
                    await setItemPickerEmpreendimento(Item);
                    await setCodEmpObra(Item.KEY_CDEMP_CDOBR_BD)
                    console.log(`>>>>>>***** 2 - Obra Selecionada => ${Item.NM_Obra} *****<<<<<<<<`)

                    api.get(`/getFiltro?codEmp=${getCodEmp}&codEmpObra=${Item.KEY_CDEMP_CDOBR_BD}&produto=${getProduto}&tabelaEmp=${tabelaEmp}`).then(async response => {
                      await setListaPickerGrupo(response.data.filtroEmpresas)
                      await setListaPickerProduto(response.data.filtroProdutos)
                      console.log(`>>>>>>***** 3 - Retorna Array com dados de empresa *****<<<<<<<<`)
                      console.log(response.data.filtroEmpresas)
                    })
                  }} text={Item.NM_Obra} />} itemPredicate={(Texto: string, Item: Objeto.EmpreendimentoPicker) => { return (Item.NM_Obra ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                  <Button className="selector" style={{ background: "#ffffff", color: "#13455e", border: "none", boxShadow: "none", borderRadius: "5px", outline: "none", width: "150px", display: "flex", alignItems: "center", justifyContent: "space-between" }} text={getItemPickerEmpreendimento?.NM_Obra.substring(0, 10).concat("...") ?? "Obra"} rightIcon="double-caret-vertical" />
                </PickerEmpreendimento>
                {getItemPickerEmpreendimento && <Icon icon="filter-remove" style={{ marginLeft: "5px", cursor: "pointer" }} iconSize={15} onClick={async () => {
                  await setItemPickerGrupo(undefined);
                  await setItemPickerEmpreendimento(undefined);
                  await setItemPickerProduto(undefined);
                  await setCodEmp(undefined)
                  await setCodEmpObra(undefined)
                  await setProduto(undefined)
                  

                  await setListaPickerGrupo(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroEmpresas);
                  await setListaPickerEmpreendimento(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroObras);
                  await setListaPickerProduto(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroProdutos);
                }} />}
                <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />
                {/* Data Picker */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "300px" }}>
                  <FormGroup className="place" label="Período:" labelFor="DataDeInicio" inline={true} style={{ marginTop: "15px" }}>
                    <div style={{ width: "100px" }}>
                      <DateInput dayPickerProps={PropriedadesDeCalendario} formatDate={(date, locale) => moment(date).locale(moment.locale(locale)).format("DD/MM/YYYY")}
                        parseDate={(str, locale) => moment(str, "DD/MM/YYYY").locale(moment.locale(locale)).toDate()}
                        placeholder={"Data Início"} value={getFormularioDataDeInicio} maxDate={getFormularioDataDeTermino}
                        onChange={async (DataSelecionada: Date) => {
                          console.log(DataSelecionada)
                          if (DataSelecionada != null) {
                            await setFormularioDataDeInicio(DataSelecionada)
                          }
                          else {
                            await setFormularioDataDeInicio(getFormularioDataDeInicio)
                          }
                        }}>
                      </DateInput>
                    </div>
                  </FormGroup>
                  <span>à</span>
                  <FormGroup className="place" label="" labelFor="" inline={true} style={{ marginTop: "15px" }}>
                    <div style={{ width: "100px" }}>
                      <DateInput dayPickerProps={PropriedadesDeCalendario} formatDate={(date, locale) => moment(date).locale(moment.locale(locale)).format("DD/MM/YYYY")}
                        parseDate={(str, locale) => moment(str, "DD/MM/YYYY").locale(moment.locale(locale)).toDate()}
                        placeholder={"Data Final"} value={getFormularioDataDeTermino} minDate={getFormularioDataDeInicio}
                        onChange={async (DataSelecionada: Date) => {
                          console.log(DataSelecionada)
                          if (DataSelecionada != null && DataSelecionada < getFormularioDataDeInicio) {
                            await setFormularioDataDeInicio(DataSelecionada)
                          }
                          if (DataSelecionada != null) {
                            await setFormularioDataDeTermino(DataSelecionada)
                          }
                          else if (DataSelecionada == null) {
                            await setFormularioDataDeTermino(getFormularioDataDeTermino)
                          }
                        }}>
                      </DateInput>
                    </div>
                  </FormGroup>
                </div>
                <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />
              </div>
              <div style={{ marginRight: "6.3%", width: "325px", height: "100%", marginLeft: "20px", display: "flex", alignItems: "center", justifyContent: "space-between", background: "0" }}>
                <div style={{ display: "flex", flexDirection: "column", fontSize: "12px", marginBottom: "-10px" }}>
                  {
                   /*  tabelaEmp === "Espaco" &&
                    <>
                      <Checkbox onClick={async () => { getCheckEmpresa === false ? await setCheckEmpresa(true) : await setCheckEmpresa(false) }} label="Empresa" defaultIndeterminate={false} checked={getCheckEmpresa} />
                      <Checkbox onClick={async () => { getCheckPessoais === false ? await setCheckPessoais(true) : await setCheckPessoais(false) }} label="Pessoais" defaultIndeterminate={false} checked={getCheckPessoais} />
                      <Checkbox onClick={async () => { getCheckEmpreendimentos === false ? await setCheckEmpreendimentos(true) : await setCheckEmpreendimentos(false) }} label="Empreendimentos" defaultIndeterminate={false} checked={getCheckEmpreendimentos} />
                    </>
                  }
                  {
                    tabelaEmp !== "Espaco" && */
                    <>
                      <Checkbox onClick={async () => setVisualizacao("validacao")} label="Validação" defaultIndeterminate={false} checked={visualizacao === "validacao"} />
                      <Checkbox onClick={async () => setVisualizacao("fluxo de caixa")} label="Fluxo de caixa" defaultIndeterminate={false} checked={visualizacao === "fluxo de caixa"} />
                      <Checkbox onClick={async () => setVisualizacao("fluxo por obra")} label="Fluxo por obra" defaultIndeterminate={false} checked={visualizacao === "fluxo por obra"} />
                    </>
                  }
                </div>

                <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />
                <div style={{     display: "flex", flexDirection: "column", height: "100%", background: "0", width: "150px", padding: "10px 0 2px 0", alignItems: "center", justifyContent: "space-between" }}>
                  <div className="hoverize" style={{ width: "110px", height: "30px", background: "#ffffff", fontSize: "13px", color: "#175377", boxShadow: "0px 0px 0px 1px #d8d8d8", padding: "0 5px", borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "space-around", cursor: "pointer" }}
                    onClick={async () => {
                      await setFilterClicked(false)

                      await setCollapse(false);
                      await setTableSelected(-1);
                      await setDivisao("'Empresa'", async (Item: string) => {
                        await api.get(`/saldo_inicial?tabelaEmp=${tabelaEmp}&dataInicial=${moment(getFormularioDataDeInicio).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino).format('YYYY-MM-DD')}&codEmp=${getCodEmp?.split("-")[1]}`).then(res => {
                          setSaldoInicial(res.data);
                        })
                        await api.get(`/${fluxoTipo}?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&produto=${getProduto}&divisao=${Item}&tabelaEmp=${tabelaEmp}`).then(async res => {
                          await setFluxoData(res.data)
                          await setFilterClicked(true)
                          await setDivisao("", async (item: string) => null)
                          await setTableSelected(7);
                        })
                      })
                      // if (getCheckEmpresa || getCheckPessoais || getCheckEmpreendimentos) {
                     /*  if (false) {
                        if (getCheckEmpresa && !getCheckPessoais && !getCheckEmpreendimentos) {
                          await setCollapse(false);
                          await setTableSelected(-1);
                          await setDivisao("'Empresa'", async (Item: string) => {
                            await api.get(`/saldo_inicial?tabelaEmp=Rio&dataInicial=${moment(getFormularioDataDeInicio).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino).format('YYYY-MM-DD')}&codEmp=${getCodEmp?.split("-")[1]}`).then(res => {
                              setSaldoInicial(res.data);
                            })
                            await api.get(`/${fluxoTipo}?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&produto=${getProduto}&divisao=${Item}&tabelaEmp=${tabelaEmp}`).then(async res => {
                              await setFluxoData(res.data)
                              await setFilterClicked(true)
                              await setDivisao("", async (item: string) => null)
                              await setTableSelected(7);
                            })
                          })
                        }
                        else if (!getCheckEmpresa && getCheckPessoais && !getCheckEmpreendimentos) {
                          await setCollapse(false);
                          await setTableSelected(-1);
                          console.log("!getCheckEmpresa && getCheckPessoais && !getCheckEmpreendimentos")
                          await setDivisao("'Pessoais'", async (Item: string) => {
                            api.get(`/${fluxoTipo}?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&produto=${getProduto}&divisao=${Item}&tabelaEmp=${tabelaEmp}`).then(async res => {
                              await setFluxoData(res.data)
                              await setFilterClicked(true)
                              await setDivisao("", async (item: string) => null)
                              await setTableSelected(7);
                            })
                          })
                        }
                        else if (!getCheckEmpresa && !getCheckPessoais && getCheckEmpreendimentos) {
                          await setCollapse(false);
                          await setTableSelected(-1);
                          console.log("!getCheckEmpresa && !getCheckPessoais && getCheckEmpreendimentos")
                          await setDivisao("'Empreendimentos'", async (Item: string) => {
                            api.get(`/${fluxoTipo}?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&produto=${getProduto}&divisao=${Item}&tabelaEmp=${tabelaEmp}`).then(async res => {
                              await setFluxoData(res.data)
                              await setFilterClicked(true)
                              await setDivisao("", async (item: string) => null)
                              await setTableSelected(7);
                            })
                          })
                        }
                        else if (getCheckEmpresa && getCheckPessoais && !getCheckEmpreendimentos) {
                          await setCollapse(false);
                          await setTableSelected(-1);
                          console.log("getCheckEmpresa && getCheckPessoais && !getCheckEmpreendimentos")
                          await setDivisao("'Empresa', 'Pessoais'", async (Item: string) => {
                            api.get(`/${fluxoTipo}?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&produto=${getProduto}&divisao=${Item}&tabelaEmp=${tabelaEmp}`).then(async res => {
                              await setFluxoData(res.data)
                              await setFilterClicked(true)
                              await setDivisao("", async (item: string) => null)
                              await setTableSelected(7);
                            })
                          })
                        }
                        else if (getCheckEmpresa && !getCheckPessoais && getCheckEmpreendimentos) {
                          await setCollapse(false);
                          await setTableSelected(-1);
                          console.log("getCheckEmpresa && !getCheckPessoais && getCheckEmpreendimentos")
                          await setDivisao("'Empresa', 'Empreendimentos'", async (Item: string) => {
                            api.get(`/${fluxoTipo}?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&produto=${getProduto}&divisao=${Item}&tabelaEmp=${tabelaEmp}`).then(async res => {
                              await setFluxoData(res.data)
                              await setFilterClicked(true)
                              await setDivisao("", async (item: string) => null)
                              await setTableSelected(7);
                            })
                          })
                        }
                        else if (!getCheckEmpresa && getCheckPessoais && getCheckEmpreendimentos) {
                          await setCollapse(false);
                          await setTableSelected(-1);
                          console.log("!getCheckEmpresa && getCheckPessoais && getCheckEmpreendimentos")
                          await setDivisao("'Pessoais', 'Empreendimentos'", async (Item: string) => {
                            api.get(`/${fluxoTipo}?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&produto=${getProduto}&divisao=${Item}&tabelaEmp=${tabelaEmp}`).then(async res => {
                              await setFluxoData(res.data)
                              await setFilterClicked(true)
                              await setDivisao("", async (item: string) => null)
                              await setTableSelected(7);
                            })
                          })
                        }
                        else if (getCheckEmpresa && getCheckPessoais && getCheckEmpreendimentos) {
                          await setCollapse(false);
                          await setTableSelected(-1);
                          console.log("getCheckEmpresa && getCheckPessoais && getCheckEmpreendimentos")
                          await setDivisao("'Empresa', 'Pessoais', 'Empreendimentos'", async (Item: string) => {
                            api.get(`/${fluxoTipo}?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&produto=${getProduto}&divisao=${Item}&tabelaEmp=${tabelaEmp}`).then(async res => {
                              await setFluxoData(res.data)
                              await setFilterClicked(true)
                              await setDivisao("", async (item: string) => null)
                              await setTableSelected(7);
                            })
                          })
                        }
                      } */
                      // }
                      // else {
                      //   alert("Selecione pelo menos uma divisão")
                      // }
                    }}>
                    <Icon iconSize={10} color="#175372" style={{ transform: getFilterClicked ? "rotate(0deg)" : "rotate(-360deg)", transition: getFilterClicked ? "transform 2s" : "" }} icon="search" />
                    <span>Pesquisar</span>
                  </div>
                  <div className="hoverize" style={{width: "110px", height: "30px", background: "#175372", fontSize: "13px", color: "#ffffff", boxShadow: "0px 0px 0px 1px #d8d8d8", padding: "0 5px", borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "space-around", cursor: "pointer", pointerEvents: getQuerysLoading ? "none" : "initial" }}
                    onClick={async () => {
                      if (!getQuerysLoading) {
                        await setQuerysLoading(true);
                        await pythonApi.get(`/querysRun/${tabelaEmp}`).then(async response => {
                          await setQuerysTime([response.data.started, response.data.finished])
                          await setQuerysLoading(false)
                        })
                      }
                    }}>
                    {!getQuerysLoading && <Icon iconSize={10} color="#ffffff" style={{ transform: getFilterClicked ? "rotate(0deg)" : "rotate(-360deg)", transition: getFilterClicked ? "transform 2s" : "" }} icon="repeat" />}
                    {getQuerysLoading &&
                      <Lottie
                        options={{
                          loop: true,
                          autoplay: true,
                          animationData: LottieFiles.LoadingQuerys,
                          rendererSettings: {
                            preserveAspectRatio: "xMidYMid slice"
                          }
                        }}
                        height={17}
                        width={17}
                      />}
                    {!getQuerysLoading && <span>Atualizar</span>}
                  </div>
                  <span style={{ fontSize: "9px", color: "#ff6961" }}>Atualizado às {getQuerysTime[1]}</span>
                </div>
              </div>
            </div>}

          {getTableSelected === 12 &&
            <div style={{ width: "100%", height: "100%", backgroundColor: "0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", width: "70%", minWidth: "1005px", background: "0", alignItems: "center", justifyContent: "space-between", paddingLeft: "2%" }}>
                <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />
                {/* Grupo Picker */}
                <PickerGrupo items={getListaPickerGrupo} onItemSelect={async () => { }} noResults={<MenuItem disabled={true} text="Sem resultados disponíveis" />}
                  itemRenderer={(Item: Objeto.GrupoModel) => <MenuItem onClick={async () => {
                    await setItemPickerGrupo(Item);
                    await setCodEmp(Item.KEY_CDEMP_BD);
                    console.log(`getFiltro?codEmp=${Item.KEY_CDEMP_BD}&codEmpObra=${getCodEmpObra}&produto=${getProduto}&tabelaEmp=${tabelaEmp}`)
                    api.get(`/getFiltro?codEmp=${Item.KEY_CDEMP_BD}&codEmpObra=${getCodEmpObra}&produto=${getProduto}&tabelaEmp=${tabelaEmp}`).then(async response => {
                      await setListaPickerEmpreendimento(response.data.filtroObras)
                      await setListaPickerProduto(response.data.filtroProdutos)
                      console.log(getProduto)
                      console.log(getCodEmpObra)
                    })
                    //await setListaPickerProduto(await (await (api.get(`/getProduto?codEmpObra=${getCodEmpObra}&codEmp=${getCodEmp}`))).data);
                  }} text={Item.NM_Empresa} />} itemPredicate={(Texto: string, Item: Objeto.GrupoModel) => { return (Item.NM_Empresa ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                  <Button className="selector" style={{ background: "#ffffff", color: "#13455e", border: "none", boxShadow: "none", borderRadius: "5px", outline: "none", width: "150px", display: "flex", alignItems: "center", justifyContent: "space-between" }} text={getItemPickerGrupo?.NM_Empresa.substring(0, 10).concat("...") ?? "Empresa"} rightIcon="double-caret-vertical" />
                </PickerGrupo>
                {getItemPickerGrupo && <Icon icon="filter-remove" style={{ marginLeft: "5px", cursor: "pointer" }} iconSize={15} onClick={async () => {
                  await setItemPickerGrupo(undefined);
                  await setItemPickerEmpreendimento(undefined);
                  await setItemPickerProduto(undefined);
                  await setCodEmp(undefined)
                  await setCodEmpObra(undefined)
                  await setProduto(undefined)

                  await setListaPickerGrupo(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroEmpresas);
                  await setListaPickerEmpreendimento(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroObras);
                  await setListaPickerProduto(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroProdutos);
                }} />}
                {/* Empreendimento Picker */}
                <PickerEmpreendimento popoverProps={{ popoverClassName: "bp3-multi-select-popover" }} items={getListaPickerEmpreendimento} onItemSelect={async () => { }} noResults={<MenuItem disabled={true} text="Sem resultados disponíveis" />}
                  itemRenderer={(Item: Objeto.EmpreendimentoPicker) => <MenuItem onClick={async () => {
                    await setItemPickerEmpreendimento(Item);
                    await setCodEmpObra(Item.KEY_CDEMP_CDOBR_BD)

                    api.get(`/getFiltro?codEmp=${getCodEmp}&codEmpObra=${Item.KEY_CDEMP_CDOBR_BD}&produto=${getProduto}&tabelaEmp=${tabelaEmp}`).then(async response => {
                      await setListaPickerGrupo(response.data.filtroEmpresas)
                      await setListaPickerProduto(response.data.filtroProdutos)
                      console.log(`/getFiltro?codEmp=${getCodEmp}&codEmpObra=${Item.KEY_CDEMP_CDOBR_BD}&produto=${getProduto}&tabelaEmp=${tabelaEmp}`)
                      console.log(response.data.filtroEmpresas)
                    })
                  }} text={Item.NM_Obra} />} itemPredicate={(Texto: string, Item: Objeto.EmpreendimentoPicker) => { return (Item.NM_Obra ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                  <Button className="selector" style={{ background: "#ffffff", color: "#13455e", border: "none", boxShadow: "none", borderRadius: "5px", outline: "none", width: "150px", display: "flex", alignItems: "center", justifyContent: "space-between" }} text={getItemPickerEmpreendimento?.NM_Obra.substring(0, 10).concat("...") ?? "Obra"} rightIcon="double-caret-vertical" />
                </PickerEmpreendimento>
                {getItemPickerEmpreendimento && <Icon icon="filter-remove" style={{ marginLeft: "5px", cursor: "pointer" }} iconSize={15} onClick={async () => {
                  await setItemPickerGrupo(undefined);
                  await setItemPickerEmpreendimento(undefined);
                  await setItemPickerProduto(undefined);
                  await setCodEmp(undefined)
                  await setCodEmpObra(undefined)
                  await setProduto(undefined)

                  await setListaPickerGrupo(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroEmpresas);
                  await setListaPickerEmpreendimento(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroObras);
                  await setListaPickerProduto(await (await (api.get(`/getFiltro?codEmp=undefined&codEmpObra=undefined&produto=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroProdutos);
                }} />}
                <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />
                {/* Data Picker */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "300px" }}>
                  <FormGroup className="place" label="Período:" labelFor="DataDeInicio" inline={true} style={{ marginTop: "15px" }}>
                    <div style={{ width: "100px" }}>
                      <DateInput dayPickerProps={PropriedadesDeCalendario} formatDate={(date, locale) => moment(date).locale(moment.locale(locale)).format("DD/MM/YYYY")}
                        parseDate={(str, locale) => moment(str, "DD/MM/YYYY").locale(moment.locale(locale)).toDate()}
                        placeholder={"Data Início"} value={getFormularioDataDeInicio} maxDate={getFormularioDataDeTermino}
                        onChange={async (DataSelecionada: Date) => {
                          console.log(DataSelecionada)
                          if (DataSelecionada != null) {
                            await setFormularioDataDeInicio(DataSelecionada)
                          }
                          else {
                            await setFormularioDataDeInicio(getFormularioDataDeInicio)
                          }
                        }}>
                      </DateInput>
                    </div>
                  </FormGroup>
                  <span>à</span>
                  <FormGroup className="place" label="" labelFor="" inline={true} style={{ marginTop: "15px" }}>
                    <div style={{ width: "100px" }}>
                      <DateInput dayPickerProps={PropriedadesDeCalendario} formatDate={(date, locale) => moment(date).locale(moment.locale(locale)).format("DD/MM/YYYY")}
                        parseDate={(str, locale) => moment(str, "DD/MM/YYYY").locale(moment.locale(locale)).toDate()}
                        placeholder={"Data Final"} value={getFormularioDataDeTermino} minDate={getFormularioDataDeInicio}
                        onChange={async (DataSelecionada: Date) => {
                          console.log(DataSelecionada)
                          if (DataSelecionada != null && DataSelecionada < getFormularioDataDeInicio) {
                            await setFormularioDataDeInicio(DataSelecionada)
                          }
                          if (DataSelecionada != null) {
                            await setFormularioDataDeTermino(DataSelecionada)
                          }
                          else if (DataSelecionada == null) {
                            await setFormularioDataDeTermino(getFormularioDataDeTermino)
                          }
                        }}>
                      </DateInput>
                    </div>
                  </FormGroup>
                </div>
                <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />
              </div>
              <div style={{ marginRight: "6.3%", width: "325px", height: "100%", marginLeft: "20px", display: "flex", alignItems: "center", justifyContent: "space-between", background: "0" }}>                <div style={{ display: "flex", flexDirection: "column", height: "100%", background: "0", width: "150px", padding: "10px 0 2px 0", alignItems: "center", justifyContent: "space-between" }}>
                <div className="hoverize" style={{ width: "110px", height: "30px", background: "#ffffff", fontSize: "13px", color: "#175372", boxShadow: "0px 0px 0px 1px #d8d8d8", padding: "0 5px", borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "space-around", cursor: "pointer" }}
                  onClick={async () => {
                    await setFilterClicked(false)
                    if (getFormularioDataDeInicio && getFormularioDataDeTermino) {
                      await setCollapse(false);
                      await setTableSelected(-1);
                      await api.get(`/Desembolso?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&tabelaEmp=${tabelaEmp}`).then(async res => {
                        await setDesembolsoData(res.data)
                        await setFilterClicked(true)
                        await setTableSelected(12);
                      })
                    }
                    else {
                      alert("Selecione um período")
                    }
                  }}>
                  <Icon iconSize={10} color="#175372" style={{ transform: getFilterClicked ? "rotate(0deg)" : "rotate(-360deg)", transition: getFilterClicked ? "transform 2s" : "" }} icon="search" />
                  <span>Pesquisar</span>
                </div>
                <div className="hoverize" style={{ width: "110px", height: "30px", background: "#175372", fontSize: "13px", color: "#ffffff", boxShadow: "0px 0px 0px 1px #d8d8d8", padding: "0 5px", borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "space-around", cursor: "pointer", pointerEvents: getQuerysLoading ? "none" : "initial" }}
                  onClick={async () => {
                    if (!getQuerysLoading) {
                      await setQuerysLoading(true);
                      await pythonApi.get(`/querysRun/${tabelaEmp}`).then(async response => {
                        await setQuerysTime([response.data.started, response.data.finished])
                        await setQuerysLoading(false)
                      })
                    }
                  }}>
                  {!getQuerysLoading && <Icon iconSize={10} color="#ffffff" style={{ transform: getFilterClicked ? "rotate(0deg)" : "rotate(-360deg)", transition: getFilterClicked ? "transform 2s" : "" }} icon="repeat" />}
                  {getQuerysLoading &&
                    <Lottie
                      options={{
                        loop: true,
                        autoplay: true,
                        animationData: LottieFiles.LoadingQuerys,
                        rendererSettings: {
                          preserveAspectRatio: "xMidYMid slice"
                        }
                      }}
                      height={17}
                      width={17}
                    />}
                  {!getQuerysLoading && <span>Atualizar</span>}
                </div>
                <span style={{ fontSize: "9px", color: "#ff6961" }}>Atualizado às {getQuerysTime[1]}</span>
              </div>
              </div>
            </div>}
          {(getTableSelected === 8 || getTableSelected === 9) &&
            <div style={{ width: "100%", height: "100%", backgroundColor: "0", display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex", width: "70%", height: "100%", minWidth: "783px", background: "0", alignItems: "center", justifyContent: "space-between", paddingLeft: "2%" }}>
                <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />
                {/* Grupo Picker */}
                <PickerGrupo popoverProps={{ popoverClassName: "bp3-multi-select-popover" }} items={getListaPickerGrupo} onItemSelect={async () => { }} noResults={<MenuItem disabled={true} text="Sem resultados disponíveis" />}
                  itemRenderer={(Item: Objeto.GrupoModel) => <MenuItem onClick={async () => {
                    await setItemPickerGrupo(Item);
                    await setCodEmp(Item.KEY_CDEMP_BD);
                    //console.log(`getFiltroPlan?codEmp=${Item.KEY_CDEMP_BD}&codEmpObra=${getCodEmpObra}`)
                    api.get(`/getFiltroPlan?codEmp=${Item.KEY_CDEMP_BD}&codEmpObra=${getCodEmpObra}&tabelaEmp=${tabelaEmp}`).then(async response => {
                      await setListaPickerEmpreendimento(response.data.filtroObras)
                      // console.log(getProduto)
                      // console.log(getCodEmpObra)
                    })
                  }} text={Item.NM_Empresa} />} itemPredicate={(Texto: string, Item: Objeto.GrupoModel) => { return (Item.NM_Empresa ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                  <Button className="selector" style={{ background: "#ffffff", color: "#13455e", border: "none", boxShadow: "none", borderRadius: "5px", outline: "none", width: "150px", display: "flex", alignItems: "center", justifyContent: "space-between" }} text={getItemPickerGrupo?.NM_Empresa.substring(0, 10).concat("...") ?? "Empresa"} rightIcon="double-caret-vertical" />
                </PickerGrupo>
                {getItemPickerGrupo && <Icon icon="filter-remove" style={{ marginLeft: "5px", cursor: "pointer" }} iconSize={15} onClick={async () => {
                  await setItemPickerGrupo(undefined);
                  await setItemPickerEmpreendimento(undefined);
                  await setItemPickerStatus(undefined);
                  await setCodEmp(undefined)
                  await setCodEmpObra(undefined)
                  await setStatus(undefined)

                  await setListaPickerGrupo(await (await (api.get(`/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroEmpresas);
                  await setListaPickerEmpreendimento(await (await (api.get(`/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroObras);
                }} />}
                {/* Empreendimento Picker */}
                <PickerEmpreendimento popoverProps={{ popoverClassName: "bp3-multi-select-popover" }} items={getListaPickerEmpreendimento} onItemSelect={async () => { }} noResults={<MenuItem disabled={true} text="Sem resultados disponíveis" />}
                  itemRenderer={(Item: Objeto.EmpreendimentoPicker) => <MenuItem onClick={async () => {
                    await setItemPickerEmpreendimento(Item);
                    await setCodEmpObra(Item.KEY_CDEMP_CDOBR_BD)

                    api.get(`/getFiltroPlan?codEmp=${getCodEmp}&codEmpObra=${Item.KEY_CDEMP_CDOBR_BD}`).then(async response => {
                      await setListaPickerGrupo(response.data.filtroEmpresas)
                      //console.log(`/getFiltroPlan?codEmp=${getCodEmp}&codEmpObra=${Item.KEY_CDEMP_CDOBR_BD}`)
                      //console.log(response.data.filtroEmpresas)
                    })
                  }} text={Item.KEY_CDEMP_CDOBR_BD} />} itemPredicate={(Texto: string, Item: Objeto.EmpreendimentoPicker) => { return (Item.KEY_CDEMP_CDOBR_BD ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                  <Button className="selector" style={{ background: "#ffffff", color: "#13455e", border: "none", boxShadow: "none", borderRadius: "5px", outline: "none", width: "150px", display: "flex", alignItems: "center", justifyContent: "space-between" }} text={getItemPickerEmpreendimento?.KEY_CDEMP_CDOBR_BD.substring(0, 15) ?? "Obra"} rightIcon="double-caret-vertical" />
                </PickerEmpreendimento>
                {getItemPickerEmpreendimento && <Icon icon="filter-remove" style={{ marginLeft: "5px", cursor: "pointer" }} iconSize={15} onClick={async () => {
                  await setItemPickerGrupo(undefined);
                  await setItemPickerEmpreendimento(undefined);
                  await setItemPickerStatus(undefined);
                  await setCodEmp(undefined)
                  await setCodEmpObra(undefined)
                  await setStatus(undefined)

                  await setListaPickerGrupo(await (await (api.get(`/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroEmpresas);
                  await setListaPickerEmpreendimento(await (await (api.get(`/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroObras);
                }} />}
                {/* Status Picker */}
                {getTableSelected === 8 && <PickerStatus popoverProps={{ popoverClassName: "bp3-multi-select-popover" }} items={getListaPickerStatus} onItemSelect={async () => { }} noResults={<MenuItem disabled={true} text="Sem resultados disponíveis" />}
                  itemRenderer={(Item: Objeto.StatusPicker) => <MenuItem onClick={async () => {
                    await setItemPickerStatus(Item);
                    await setStatus(Item.statusflx);
                    console.log(Item.statusflx)
                  }} text={Item.statusflx} />} itemPredicate={(Texto: string, Item: Objeto.StatusPicker) => { return (Item.statusflx ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                  <Button className="selector" style={{ background: "#ffffff", color: "#13455e", border: "none", boxShadow: "none", borderRadius: "5px", outline: "none", width: "150px", display: "flex", alignItems: "center", justifyContent: "space-between" }} text={getItemPickerStatus?.statusflx.substring(0, 10).concat("...") ?? "Status"} rightIcon="double-caret-vertical" />
                </PickerStatus>}
                {getTableSelected === 8 && getItemPickerStatus && <Icon icon="filter-remove" style={{ marginLeft: "5px", cursor: "pointer" }} iconSize={15} onClick={async () => {
                  await setItemPickerGrupo(undefined);
                  await setItemPickerEmpreendimento(undefined);
                  await setItemPickerStatus(undefined);
                  await setCodEmp(undefined)
                  await setCodEmpObra(undefined)
                  await setStatus(undefined)

                  await setListaPickerGrupo(await (await (api.get(`/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroEmpresas);
                  await setListaPickerEmpreendimento(await (await (api.get(`/getFiltroPlan?codEmp=undefined&codEmpObra=undefined&tabelaEmp=${tabelaEmp}`))).data.filtroObras);
                }} />}
                <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />
                {/* Data Picker */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "300px" }}>
                  <FormGroup className="place" label="Período:" labelFor="" inline={true} style={{ marginTop: "15px" }}>
                    <div style={{ width: "100px" }}>
                      <DateInput dayPickerProps={PropriedadesDeCalendario} formatDate={(date, locale) => moment(date).locale(moment.locale(locale)).format("DD/MM/YYYY")}
                        parseDate={(str, locale) => moment(str, "DD/MM/YYYY").locale(moment.locale(locale)).toDate()}
                        placeholder={"Data Início"} value={getFormularioDataDeInicio} maxDate={getFormularioDataDeTermino}
                        onChange={async (DataSelecionada: Date) => {
                          //console.log(DataSelecionada)
                          if (DataSelecionada != null) {
                            await setFormularioDataDeInicio(DataSelecionada)
                          }
                          else {
                            await setFormularioDataDeInicio(getFormularioDataDeInicio)
                          }
                        }}>
                      </DateInput>
                    </div>
                  </FormGroup>
                  <span>à</span>
                  <FormGroup className="place" label="" labelFor="DataDeTermino" inline={true} style={{ marginTop: "15px" }}>
                    <div style={{ width: "100px" }}>
                      <DateInput dayPickerProps={PropriedadesDeCalendario} formatDate={(date, locale) => moment(date).locale(moment.locale(locale)).format("DD/MM/YYYY")}
                        parseDate={(str, locale) => moment(str, "DD/MM/YYYY").locale(moment.locale(locale)).toDate()}
                        placeholder={"Data Final"} value={getFormularioDataDeTermino} minDate={getFormularioDataDeInicio} maxDate={new Date("2050/12/30")}
                        onChange={async (DataSelecionada: Date) => {
                          //console.log(DataSelecionada)
                          if (DataSelecionada != null && DataSelecionada < getFormularioDataDeInicio) {
                            await setFormularioDataDeInicio(DataSelecionada)
                          }
                          if (DataSelecionada != null) {
                            await setFormularioDataDeTermino(DataSelecionada)
                          }
                          else if (DataSelecionada == null) {
                            await setFormularioDataDeTermino(getFormularioDataDeTermino)
                          }
                        }}>
                      </DateInput>
                    </div>
                  </FormGroup>
                </div>
                <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />
              </div>
              <div style={{ marginRight: "6.3%", width: "325px", height: "100%", marginLeft: "20px", display: "flex", alignItems: "center", justifyContent: "space-between", background: "0" }}>
                <div style={{ display: "flex", flexDirection: "column", fontSize: "12px", marginBottom: "-10px" }}>
                  <Checkbox style={{ height: "10px" }} onClick={async () => { getCheckEmpresa === false ? await setCheckEmpresa(true) : await setCheckEmpresa(false) }} label="Empresa" defaultIndeterminate={false} checked={getCheckEmpresa} />
                  <Checkbox style={{ height: "10px" }} onClick={async () => { getCheckPessoais === false ? await setCheckPessoais(true) : await setCheckPessoais(false) }} label="Pessoais" defaultIndeterminate={false} checked={getCheckPessoais} />
                  <Checkbox style={{ height: "10px" }} onClick={async () => { getCheckEmpreendimentos === false ? await setCheckEmpreendimentos(true) : await setCheckEmpreendimentos(false) }} label="Empreendimentos" defaultIndeterminate={false} checked={getCheckEmpreendimentos} />
                </div>
                <Divider style={{ width: "1px", height: "30px", backgroundColor: "#afafaf" }} />
                <div style={{ display: "flex", flexDirection: "column", height: "100%", background: "0", width: "150px", padding: "10px 0 2px 0", alignItems: "center", justifyContent: "space-between" }}>
                  <div className="hoverize" style={{ width: "110px", height: "30px", background: "#ffffff", fontSize: "13px", color: "#175372", boxShadow: "0px 0px 0px 1px #d8d8d8", padding: "0 5px", borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "space-around", cursor: "pointer" }}
                    onClick={async () => {
                      await setFilterClicked(false)
                      console.log((getCheckEmpresa || getCheckPessoais || getCheckEmpreendimentos))
                      if (getTableSelected === 8) {
                        if (getCheckEmpresa || getCheckPessoais || getCheckEmpreendimentos) {
                          if (getCheckEmpresa && !getCheckPessoais && !getCheckEmpreendimentos) {
                            await setCollapse(false);
                            await setTableSelected(-1);
                            await setDivisao("'Empresa'", async (Item: string) => {
                              console.log("getCheckEmpresa && !getCheckPessoais && !getCheckEmpreendimentos")
                              api.get(`/Planejamento?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&divisao=${Item}&status=${getStatus}&tabelaEmp=${tabelaEmp}`).then(async res => {
                                await setPlanejamentoData(res.data)
                                await setFilterClicked(true)
                                await setDivisao("", async (item: string) => null)
                                await setTableSelected(8);
                              })
                            })
                          }
                          else if (!getCheckEmpresa && getCheckPessoais && !getCheckEmpreendimentos) {
                            await setCollapse(false);
                            await setTableSelected(-1);
                            console.log("!getCheckEmpresa && getCheckPessoais && !getCheckEmpreendimentos")
                            await setDivisao("'Pessoais'", async (Item: string) => {
                              api.get(`/Planejamento?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&divisao=${Item}&status=${getStatus}&tabelaEmp=${tabelaEmp}`).then(async res => {
                                await setPlanejamentoData(res.data)
                                await setFilterClicked(true)
                                await setDivisao("", async (item: string) => null)
                                await setTableSelected(8);
                              })
                            })
                          }
                          else if (!getCheckEmpresa && !getCheckPessoais && getCheckEmpreendimentos) {
                            await setCollapse(false);
                            await setTableSelected(-1);
                            console.log("!getCheckEmpresa && !getCheckPessoais && getCheckEmpreendimentos")
                            await setDivisao("'Empreendimentos'", async (Item: string) => {
                              api.get(`/Planejamento?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&divisao=${Item}&status=${getStatus}&tabelaEmp=${tabelaEmp}`).then(async res => {
                                await setPlanejamentoData(res.data)
                                await setFilterClicked(true)
                                await setDivisao("", async (item: string) => null)
                                await setTableSelected(8);
                              })
                            })
                          }
                          else if (getCheckEmpresa && getCheckPessoais && !getCheckEmpreendimentos) {
                            await setCollapse(false);
                            await setTableSelected(-1);
                            console.log("getCheckEmpresa && getCheckPessoais && !getCheckEmpreendimentos")
                            await setDivisao("'Empresa', 'Pessoais'", async (Item: string) => {
                              api.get(`/Planejamento?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&divisao=${Item}&status=${getStatus}&tabelaEmp=${tabelaEmp}`).then(async res => {
                                await setPlanejamentoData(res.data)
                                await setFilterClicked(true)
                                await setDivisao("", async (item: string) => null)
                                await setTableSelected(8);
                              })
                            })
                          }
                          else if (getCheckEmpresa && !getCheckPessoais && getCheckEmpreendimentos) {
                            await setCollapse(false);
                            await setTableSelected(-1);
                            console.log("getCheckEmpresa && !getCheckPessoais && getCheckEmpreendimentos")
                            await setDivisao("'Empresa', 'Empreendimentos'", async (Item: string) => {
                              api.get(`/Planejamento?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&divisao=${Item}&status=${getStatus}&tabelaEmp=${tabelaEmp}`).then(async res => {
                                await setPlanejamentoData(res.data)
                                await setFilterClicked(true)
                                await setDivisao("", async (item: string) => null)
                                await setTableSelected(8);
                              })
                            })
                          }
                          else if (!getCheckEmpresa && getCheckPessoais && getCheckEmpreendimentos) {
                            await setCollapse(false);
                            await setTableSelected(-1);
                            console.log("!getCheckEmpresa && getCheckPessoais && getCheckEmpreendimentos")
                            await setDivisao("'Pessoais', 'Empreendimentos'", async (Item: string) => {
                              api.get(`/Planejamento?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&divisao=${Item}&status=${getStatus}&tabelaEmp=${tabelaEmp}`).then(async res => {
                                await setPlanejamentoData(res.data)
                                await setFilterClicked(true)
                                await setDivisao("", async (item: string) => null)
                                await setTableSelected(8);
                              })
                            })
                          }
                          else if (getCheckEmpresa && getCheckPessoais && getCheckEmpreendimentos) {
                            await setCollapse(false);
                            await setTableSelected(-1);
                            console.log("getCheckEmpresa && getCheckPessoais && getCheckEmpreendimentos")
                            await setDivisao("'Empresa', 'Pessoais', 'Empreendimentos'", async (Item: string) => {
                              api.get(`/Planejamento?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&divisao=${Item}&status=${getStatus}&tabelaEmp=${tabelaEmp}`).then(async res => {
                                await setPlanejamentoData(res.data)
                                await setFilterClicked(true)
                                await setDivisao("", async (item: string) => null)
                                await setTableSelected(8);
                              })
                            })
                          }
                        }
                      }
                      else if (getTableSelected === 9) {
                        if (getCheckEmpresa || getCheckPessoais || getCheckEmpreendimentos) {
                          if (getCheckEmpresa && !getCheckPessoais && !getCheckEmpreendimentos) {
                            await setCollapse(false);
                            await setTableSelected(-1);
                            await setDivisao("'Empresa'", async (Item: string) => {
                              console.log("getCheckEmpresa && !getCheckPessoais && !getCheckEmpreendimentos")
                              api.get(`/APagar?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&divisao=${Item}&status=${getStatus}&tabelaEmp=${tabelaEmp}`).then(async res => {
                                await setAPagarData(res.data)
                                await setFilterClicked(true)
                                await setDivisao("", async (item: string) => null)
                                await setTableSelected(9);
                              })
                            })
                          }
                          else if (!getCheckEmpresa && getCheckPessoais && !getCheckEmpreendimentos) {
                            await setCollapse(false);
                            await setTableSelected(-1);
                            console.log("!getCheckEmpresa && getCheckPessoais && !getCheckEmpreendimentos")
                            await setDivisao("'Pessoais'", async (Item: string) => {
                              api.get(`/APagar?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&divisao=${Item}&status=${getStatus}&tabelaEmp=${tabelaEmp}`).then(async res => {
                                await setAPagarData(res.data)
                                await setFilterClicked(true)
                                await setDivisao("", async (item: string) => null)
                                await setTableSelected(9);
                              })
                            })
                          }
                          else if (!getCheckEmpresa && !getCheckPessoais && getCheckEmpreendimentos) {
                            await setCollapse(false);
                            await setTableSelected(-1);
                            console.log("!getCheckEmpresa && !getCheckPessoais && getCheckEmpreendimentos")
                            await setDivisao("'Empreendimentos'", async (Item: string) => {
                              api.get(`/APagar?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&divisao=${Item}&status=${getStatus}&tabelaEmp=${tabelaEmp}`).then(async res => {
                                await setAPagarData(res.data)
                                await setFilterClicked(true)
                                await setDivisao("", async (item: string) => null)
                                await setTableSelected(9);
                              })
                            })
                          }
                          else if (getCheckEmpresa && getCheckPessoais && !getCheckEmpreendimentos) {
                            await setCollapse(false);
                            await setTableSelected(-1);
                            console.log("getCheckEmpresa && getCheckPessoais && !getCheckEmpreendimentos")
                            await setDivisao("'Empresa', 'Pessoais'", async (Item: string) => {
                              api.get(`/APagar?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&divisao=${Item}&status=${getStatus}&tabelaEmp=${tabelaEmp}`).then(async res => {
                                await setAPagarData(res.data)
                                await setFilterClicked(true)
                                await setDivisao("", async (item: string) => null)
                                await setTableSelected(9);
                              })
                            })
                          }
                          else if (getCheckEmpresa && !getCheckPessoais && getCheckEmpreendimentos) {
                            await setCollapse(false);
                            await setTableSelected(-1);
                            console.log("getCheckEmpresa && !getCheckPessoais && getCheckEmpreendimentos")
                            await setDivisao("'Empresa', 'Empreendimentos'", async (Item: string) => {
                              api.get(`/APagar?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&divisao=${Item}&status=${getStatus}&tabelaEmp=${tabelaEmp}`).then(async res => {
                                await setAPagarData(res.data)
                                await setFilterClicked(true)
                                await setDivisao("", async (item: string) => null)
                                await setTableSelected(9);
                              })
                            })
                          }
                          else if (!getCheckEmpresa && getCheckPessoais && getCheckEmpreendimentos) {
                            await setCollapse(false);
                            await setTableSelected(-1);
                            console.log("!getCheckEmpresa && getCheckPessoais && getCheckEmpreendimentos")
                            await setDivisao("'Pessoais', 'Empreendimentos'", async (Item: string) => {
                              api.get(`/APagar?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&divisao=${Item}&status=${getStatus}&tabelaEmp=${tabelaEmp}`).then(async res => {
                                await setAPagarData(res.data)
                                await setFilterClicked(true)
                                await setDivisao("", async (item: string) => null)
                                await setTableSelected(9);
                              })
                            })
                          }
                          else if (getCheckEmpresa && getCheckPessoais && getCheckEmpreendimentos) {
                            await setCollapse(false);
                            await setTableSelected(-1);
                            console.log("getCheckEmpresa && getCheckPessoais && getCheckEmpreendimentos")
                            await setDivisao("'Empresa', 'Pessoais', 'Empreendimentos'", async (Item: string) => {
                              api.get(`/APagar?dataInicial=${moment(getFormularioDataDeInicio, true).format('YYYY-MM-DD')}&dataFinal=${moment(getFormularioDataDeTermino, true).format('YYYY-MM-DD')}&codEmp=${getCodEmp}&codEmpObra=${getCodEmpObra}&divisao=${Item}&status=${getStatus}&tabelaEmp=${tabelaEmp}`).then(async res => {
                                await setAPagarData(res.data)
                                await setFilterClicked(true)
                                await setDivisao("", async (item: string) => null)
                                await setTableSelected(9);
                              })
                            })
                          }
                        }
                      }
                      else {
                        alert("Selecione pelo menos uma divisão")
                      }
                    }}>
                    <Icon iconSize={10} color="#175372" style={{ transform: getFilterClicked ? "rotate(0deg)" : "rotate(-360deg)", transition: getFilterClicked ? "transform 2s" : "" }} icon="search" />
                    <span>Pesquisar</span>
                  </div>
                  <div className="hoverize" style={{ width: "110px", height: "30px", background: "#175372", fontSize: "13px", color: "#ffffff", boxShadow: "0px 0px 0px 1px #d8d8d8", padding: "0 5px", borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "space-around", cursor: "pointer", pointerEvents: getQuerysLoading ? "none" : "initial" }}
                    onClick={async () => {
                      if (!getQuerysLoading) {
                        await setQuerysLoading(true);
                        await pythonApi.get(`/querysRun/${tabelaEmp}`).then(async response => {
                          await setQuerysTime([response.data.started, response.data.finished])
                          await setQuerysLoading(false)
                        })
                      }
                    }}>
                    {!getQuerysLoading && <Icon iconSize={10} color="#ffffff" style={{ transform: getFilterClicked ? "rotate(0deg)" : "rotate(-360deg)", transition: getFilterClicked ? "transform 2s" : "" }} icon="repeat" />}
                    {getQuerysLoading &&
                      <Lottie
                        options={{
                          loop: true,
                          autoplay: true,
                          animationData: LottieFiles.LoadingQuerys,
                          rendererSettings: {
                            preserveAspectRatio: "xMidYMid slice"
                          }
                        }}
                        height={17}
                        width={17}
                      />}
                    {!getQuerysLoading && <span>Atualizar</span>}
                  </div>
                  <span style={{ fontSize: "9px", color: "#ff6961" }}>Atualizado às {getQuerysTime[1]}</span>
                </div>
              </div>
            </div>
          }

        </div>
      </Collapse>
      <div className="collapse" style={{ width: "100%", height: "20px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => getCollapse === true ? setCollapse(false) : setCollapse(true)}>
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: LottieFiles.SwipeDown,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice"
            }
          }}
          height={30}
          width={30}
          style={getCollapse ? { transform: `rotate(180deg)`, transition: "transform 0.5s" } : { transform: `rotate(0deg)`, transition: "transform 0.5s" }}
        />
      </div>
      {/* Vizualizações */}
      {getTableSelected == 0 && <ComponentTable.Resumo></ComponentTable.Resumo>}
      {getTableSelected == 1 && <ComponentTable.VendasSemCessao vendasSemCessao={getVendasSemCessaoData}></ComponentTable.VendasSemCessao>}
      {getTableSelected == 2 && <ComponentTable.VendasDeCessao vendasDeCessao={getVendasDeCessaoData}></ComponentTable.VendasDeCessao>}
      {getTableSelected == 3 && <ComponentTable.VendasDistratadas vendasDistratadas={getVendasDistratadasData}></ComponentTable.VendasDistratadas>}
      {getTableSelected == 4 && <ComponentTable.Depositos depositos={getDepositosData}></ComponentTable.Depositos>}
      {getTableSelected == 5 && <ComponentTable.Provisao></ComponentTable.Provisao>}
      {getTableSelected == 6 && <ComponentTable.VendaNoTempo vendasNoTempo={getVendasNoTempoData}></ComponentTable.VendaNoTempo>}
      {/* {getTableSelected == 7 && tabelaEmp !== "Espaco" && <ComponentTable.Fluxo visualizacao={visualizacao} getItemPickerEmpreendimento={getItemPickerEmpreendimento} saldoInicial={getSaldoInicial} dataInicial={getFormularioDataDeInicio} dataFinal={getFormularioDataDeTermino} dados={getFluxoData} filter={getSearch}></ComponentTable.Fluxo>}
      {getTableSelected == 7 && localStorage.getItem('cd_emp') === "20" && <ComponentTable.FluxoEspaco saldoInicial={getSaldoInicial} dataInicial={getFormularioDataDeInicio} dataFinal={getFormularioDataDeTermino} dados={getFluxoData} filter={getSearch}></ComponentTable.FluxoEspaco>} */}
      {getTableSelected == 7 && <ComponentTable.Fluxo visualizacao={visualizacao} getItemPickerEmpreendimento={getItemPickerEmpreendimento} saldoInicial={getSaldoInicial} dataInicial={getFormularioDataDeInicio} dataFinal={getFormularioDataDeTermino} dados={getFluxoData} filter={getSearch}></ComponentTable.Fluxo>}
      {getTableSelected == 8 && <ComponentTable.Planejamento planejamento={getPlanejamentoData} dataInicial={getFormularioDataDeInicio} dataFinal={getFormularioDataDeTermino}></ComponentTable.Planejamento>}
      {getTableSelected == 9 && <ComponentTable.Realizar realizar={getAPagarData} ></ComponentTable.Realizar>}
      {getTableSelected == 10 && <ComponentTable.Financeiro ></ComponentTable.Financeiro>}
      {getTableSelected == 11 && <ComponentTable.Carteira ></ComponentTable.Carteira>}
      {getTableSelected == 12 && <ComponentTable.Desembolso dataInicial={getFormularioDataDeInicio} dataFinal={getFormularioDataDeTermino} dados={getDesembolsoData} filter={getSearch} ></ComponentTable.Desembolso>}
      {getTableSelected == -1 && <>
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: LottieFiles.LoadAnalytics,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice"
            }
          }}
          height={300}
          width={300}
          style={{ marginTop: "200px" }}
        />
      </>}
    </div>
  );
}

export default View;